import { wrapReactRouterRouting } from '@sentry/react/react-router';
import { Routes } from 'react-router';

// routes instrumented by Sentry so navigation transactions are named after the route pattern
const SentryRoutes = wrapReactRouterRouting(Routes);

export default SentryRoutes;
